// extracted by mini-css-extract-plugin
export default {"container":"NoticeList_container__vcpHW","actionArea":"NoticeList_actionArea__OZ2ga","addButton":"NoticeList_addButton__+ba0v","detailButton":"NoticeList_detailButton__Jkod1"};